import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { View, StyleSheet, TouchableHighlight, ScrollView } from "react-native";
import Text from "../components_v2/TextFont";

import Theme from "../argon-ui/Theme";
import * as AreaHelper from "../actions/AreaHelper";
import InputSearch from "../components_v2/InputSearch";
import { getDir, getIsRTL } from "../util";

/**
 * @augments{Component<props, state>}
 */
class AreaTree extends Component {
  static propTypes = {
    areas: PropTypes.array,
    onSelect: PropTypes.func,
    style: PropTypes.shape(),
    onlyAdmin: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
    };
  }

  componentDidMount() {}

  render() {
    var allAreas = this.props.areaReducer.areas;
    var tree = AreaHelper.GetTree(allAreas);
    return (
      <View style={{ direction: getDir() }}>
        <View style={style.input}>
          <InputSearch
            onChangeText={(txt) => {
              this.setState({ searchTerm: txt });
            }}
            value={this.state.searchTerm}
          />
        </View>
        <ScrollView>
          {tree.subAreas.map((sub) => {
            if (Number(sub)) {
              sub = AreaHelper.findAreaById(allAreas, sub) || {};
            }
            var displayItem = "none";
            if (
              !this.state.searchTerm ||
              sub.areaName
                .toLowerCase()
                .indexOf(this.state.searchTerm.toLowerCase().trim()) >= 0
            ) {
              if (
                !this.props.onlyAdmin ||
                sub.accessLevelValue >= 1000 // admin: 1000, support: 5000
              )
                displayItem = "flex";
            }
            return (
              <AreaSelectItem
                key={sub.areaId.toString()}
                model={sub}
                allAreas={[...allAreas]}
                disabled={
                  sub.areaId == this.props.oldAreaId ||
                  sub.areaUId === this.props.oldAreaUId
                }
                onSelect={(subId, subUId, subName) => {
                  this.props.onSelect &&
                    this.props.onSelect(
                      subId || sub.areaId,
                      subUId || sub.areaUId,
                      subName || sub.subName
                    );
                }}
                searchTerm={this.state.searchTerm}
                breadCrumb={[sub.areaName]}
                style={[style.areaSelectItem, { display: displayItem }]}
              />
            );
          })}
        </ScrollView>
      </View>
    );
  }
}

/**
 * @augments{Component<props, state>}
 */
class AreaSelectItem extends Component {
  static propTypes = {
    model: PropTypes.object,
    allAreas: PropTypes.array,
    disabled: PropTypes.bool,
    searchTerm: PropTypes.string,
    style: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
    onSelect: PropTypes.func,
    breadCrumb: PropTypes.arrayOf(PropTypes.string),
  };
  constructor(props) {
    super(props);
    this.allAreas = [...this.props.allAreas];
    //let { searchTerm } = this.props;
    this.state = {
      // searchTerm
    };
  }
  handleOnSelect = (areaId, areaUId, areaName) => {
    this.props.onSelect && this.props.onSelect(areaId, areaUId, areaName);
  };
  render() {
    var _style = this.props.style || {};
    return (
      <View>
        <TouchableHighlight
          style={_style}
          underlayColor="#f2f2f2"
          onPress={() =>
            this.handleOnSelect(
              this.props.model.areaId,
              this.props.model.areaUId,
              this.props.model.areaName
            )
          }
        >
          <View>
            <Text style={{ color: "#FFF", fontSize: 12 }}>
              {this.props.breadCrumb &&
                this.props.searchTerm &&
                this.props.breadCrumb.join(" > ")}
            </Text>

            <View style={{ flexDirection: "row" }}>
              <Text style={{ flex: 1 }}>{this.props.model.areaName}</Text>
            </View>
          </View>
        </TouchableHighlight>
        {this.props.model.subAreas && this.props.model.subAreas.length > 0 && (
          <View
            style={{
              marginRight: getIsRTL() ? 18 : 0,
              marginLeft: getIsRTL() ? 0 : 18,
            }}
          >
            {this.props.model.subAreas.map((sub) => {
              if (Number(sub)) {
                sub = AreaHelper.findAreaById(this.allAreas, sub) || {};
              }
              var displayItem = "none";
              if (
                !this.props.searchTerm ||
                sub.areaName
                  .toLowerCase()
                  .indexOf(this.props.searchTerm.toLowerCase().trim()) >= 0
              ) {
                displayItem = "flex";
              }
              return (
                <AreaSelectItem
                  key={sub.areaId.toString()}
                  model={sub}
                  allAreas={[...this.allAreas]}
                  disabled={
                    sub.areaId == this.props.oldAreaId ||
                    sub.areaUId === this.props.oldAreaUId
                  }
                  onSelect={(subId, subUId, subName) => {
                    this.handleOnSelect(
                      subId || sub.areaId,
                      subUId || sub.areaUId,
                      subName || sub.subName
                    );
                  }}
                  searchTerm={this.props.searchTerm}
                  breadCrumb={[...(this.props.breadCrumb || []), sub.areaName]}
                  style={[
                    style.areaSelectItem,
                    {
                      display: displayItem,
                      backgroundColor: Theme.COLORS.THIRED,
                    },
                  ]}
                />
              );
            })}
          </View>
        )}
      </View>
    );
  }
}

const style = StyleSheet.create({
  areaSelectItem: {
    justifyContent: "center",
    padding: 10,
    marginVertical: 3,
    // marginHorizontal: 5,
    borderRadius: 5,
    height: 45,
    backgroundColor: Theme.COLORS.THIRED,
  },
  input: {
    padding: 3,
  },
  subArea: {
    marginStart: 18,
  },
});

const mapStateToProps = (state) => {
  return {
    areaReducer: state.AreaReducer,
  };
};

export default connect(mapStateToProps)(AreaTree);
